import { createSlice } from '@reduxjs/toolkit';
import {
  OPENED_ITEMS_IN_SIDEBAR_CACHE,
  TABLE_STATES_CACHE,
} from '../../utils/constants/cache_constants.js';
const initialState = {
  isSidebarHidden: false,
  areCookiesAccepted: localStorage.getItem('cookies') === 'true' ? true : false,
  areAnalyticsAccepted:
    localStorage.getItem('google-analytics') === 'true' ? true : false,
  areMarketingAccepted:
    localStorage.getItem('google-marketing') === 'true' ? true : false,
  openedMenuItems: [],
  closedHomePageBlocks: [], // if there is title of block it will be closed
  tableStates: {},
};

const localStorageSlice = createSlice({
  name: 'localStorage',
  initialState,
  reducers: {
    acceptCookies: (state) => {
      state.areCookiesAccepted = true;

      state.areAnalyticsAccepted = true;
      localStorage.setItem('google-analytics', true);

      state.areMarketingAccepted = true;
      localStorage.setItem('google-marketing', true);

      localStorage.setItem('cookies', true);
    },
    declineCookies: (state) => {
      state.areCookiesAccepted = true;

      state.areAnalyticsAccepted = false;
      localStorage.setItem('google-analytics', false);

      state.areMarketingAccepted = false;
      localStorage.setItem('google-marketing', false);

      localStorage.setItem('cookies', true);
    },
    acceptAnalytics: (state) => {
      state.areAnalyticsAccepted = true;
      localStorage.setItem('google-analytics', true);
    },
    declineAnalytics: (state) => {
      state.areAnalyticsAccepted = false;
      localStorage.setItem('google-analytics', false);
    },
    acceptMarketing: (state) => {
      state.areMarketingAccepted = true;
      localStorage.setItem('google-marketing', true);
    },
    declineMarketing: (state) => {
      state.areMarketingAccepted = false;
      localStorage.setItem('google-marketing', false);
    },
    toggleCMSSidebar: (state, action) => {
      state.isSidebarHidden = action.payload;
      state.openedMenuItems = [];
    },
    toggleCMSNavigationGroup: (state, action) => {
      // expandSidebar is set only by user clicks, automatic opening (e.g. by URL) keeps a collapsed sidebar collapsed
      const { index, value, expandSidebar = false } = action.payload;
      let actualItems = [...state.openedMenuItems];

      if (actualItems.includes(index)) {
        // item is opened -> if value is false -> filter this item
        if (!value) {
          actualItems = actualItems.filter((item) => item !== index);
        }
      } else {
        if (!OPENED_ITEMS_IN_SIDEBAR_CACHE) actualItems = [];
        if (value) {
          // If value is true open this menu item
          actualItems.push(index);
        }
      }

      state.openedMenuItems = actualItems;
      if (expandSidebar) {
        state.isSidebarHidden = false;
      }
    },
    resetCMSNavigationGroup: (state) => {
      state.openedMenuItems = [];
    },
    toggleBlockVisibility: (state, action) => {
      const blockTitle = action.payload;

      if (state.closedHomePageBlocks.includes(blockTitle)) {
        // block title is here, remove it
        state.closedHomePageBlocks = state.closedHomePageBlocks.filter(
          (current) => current !== blockTitle,
        );
        return;
      }

      // block title is not here add it
      state.closedHomePageBlocks.push(blockTitle);
    },
    updateTableState: (state, action) => {
      const { tableId, filters, sorter, pagination } = action.payload;
      state.tableStates[tableId] = {
        filters,
        sorter,
        pagination,
      };
    },
    resetTableState: (state, action) => {
      const { tableId } = action.payload;
      if (state.tableStates[tableId]) {
        delete state.tableStates[tableId];
      }
    },
    resetAllTableStates: (state) => {
      state.tableStates = {};
    },
    initCacheStates: (state) => {
      //can happen when OPENED_ITEMS_IN_SIDEBAR_CACHE was changed from true to false and used had cached multiple menu items
      if (!OPENED_ITEMS_IN_SIDEBAR_CACHE && state.openedMenuItems?.length > 1) {
        state.openedMenuItems = [];
      }

      if (
        !TABLE_STATES_CACHE &&
        Object.keys(state.tableStates || {}).length > 0
      ) {
        state.tableStates = {};
      }
    },
  },
});

export const {
  acceptCookies,
  acceptMarketing,
  acceptAnalytics,
  declineCookies,
  declineAnalytics,
  declineMarketing,
  toggleCMSSidebar,
  toggleCMSNavigationGroup,
  toggleBlockVisibility,
  updateTableState,
  resetTableState,
  resetAllTableStates,
  resetCMSNavigationGroup,
  initCacheStates,
} = localStorageSlice.actions;

export default localStorageSlice.reducer;
